import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeHyphenFromAccount',
  standalone: false
})
export class RemoveHyphenFromAccountPipe implements PipeTransform {

  transform(accountNumber: string): string {
    let formatedAccountNumber: string = accountNumber?.replace('-', '');
    return formatedAccountNumber;
  }

}
